import '@wangeditor/editor/dist/css/style.css'

import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor'
import { useEffect, useState } from 'react';
import { i18nChangeLanguage } from '@wangeditor/editor'
import { convertToHTML } from 'draft-convert';
import { ContentState, convertFromRaw, EditorState, convertFromHTML } from 'draft-js';
import { Editor as DraftEditor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { blob } from 'stream/consumers';

// Switch language - 'en' or 'zh-CN'
i18nChangeLanguage('en')
const defaultToolbarConfig: Partial<IToolbarConfig> = {};
const defaultEditorConfig: Partial<IEditorConfig> = {};
function AppWangEditor({ value, onChange, toolbarConfig = defaultToolbarConfig, editorConfig = defaultEditorConfig }: any) {
    const [editor, setEditor] = useState<IDomEditor | null>(null);

    if (typeof onChange !== "function") {
        throw Error("onChange must be a function")
    }

    useEffect(() => {
        return () => {
            if (editor == null) return
            editor.destroy()
            setEditor(null)
        }
    }, [editor])

    const onInnerChange = (e: any) => {
        const html = e.getHtml();
        const text = e.getText();
        onChange({ html, text })
    }

    return <>
        <div style={{
            ...editorWrapperStyles
        }}>
            <Toolbar
                editor={editor}
                defaultConfig={toolbarConfig}
                mode="default"
                style={{ borderBottom: '1px solid #ccc' }}
            />
            <Editor
                defaultConfig={editorConfig}
                value={value}
                onCreated={setEditor}
                onChange={onInnerChange}
                mode="default"
                style={{ height: '500px', overflowY: 'hidden' }}
            />
        </div>
    </>

}

export default function AppEditor({ useDraft = false, ...rest }) {

    if (!useDraft) {
        return <AppWangEditor {...rest} />
    }
    return <AppDraftEditor {...rest} />

}


const AppDraftEditor = ({ value, onChange }: any) => {
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty())

    useEffect(() => {
        const blockFromHTML = convertFromHTML(value || "");
        const state = ContentState.createFromBlockArray(
            blockFromHTML.contentBlocks,
            blockFromHTML.entityMap
        )
        setEditorState(EditorState.createWithContent(state))
    }, [])

    useEffect(() => {
        if (typeof onChange === "function") {
            onChange({ html: convertToHTML(editorState.getCurrentContent()), text: editorState.getCurrentContent().getPlainText() })
        }
    }, [editorState])

    return <DraftEditor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={(editor: any) => {
            setEditorState(editor);

        }}
    />
}

const editorWrapperStyles = {
    border: '1px solid #ccc',
    zIndex: 100,
    overflow: 'auto',
};


const toolbarStyles = {
    display: 'flex',
    padding: '4px 24px',
    alignItems: 'flex-start',
    gap: '40px',
    alignSelf: 'stretch',
    borderBottom: '1px solid #ccc',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',

};
